import * as Routes from "~/routes"

export function useRoutes() {
  return {
    ...Routes,
    isActive: (route: string) => route === window.location.pathname,
    startsWith: (prefix: string) => window.location.pathname.startsWith(prefix),
  }
}
